import { createAction, props } from '@ngrx/store';
import { UserToken } from '../model/user.model';

export const login = createAction('[Login Page] User Login', props<{ userToken: UserToken }>());

export const tokenLogin = createAction('[Any Page] User Token Login on App reload', props<{ userToken: UserToken }>());

export const logout = createAction('[Top Menu] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');
export const logoutFailure = createAction(
    '[Auth] Logout Failure',
    props<{ error: any }>() // You can pass the error to handle failures
  );
  
export const robSigned = createAction('Successfully signed ROB');
export const robDecline = createAction('Decline ROB');
export const passwordChanged = createAction('Successfully changed expired password');
export const removeOtherSessions = createAction('Remove other active sessions');
